<template>
  <div class="mt-5">

    <p class="text-center">
      <button
        @click="open = !open"
        class="btn btn-info"
        type="button"
      >{{buttonLabel}} cuentas bancarias</button>
    </p>
    <div class="row" v-show="open">
      <div v-for="bank in banks"
          :key="bank.id" class="col-12 col-sm-6 col-md-4 my-3">
        <div
          class="card card-body print-endlines h-100 "
          
        >{{ bank.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBanksApi } from "@/api/modules";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      banks: [],
      open: false
    };
  },
  computed: {
    buttonLabel() {
      return this.open ? "Ocultar" : "Ver";
    }
  },
  created() {
    this.getBanks();
  },
  methods: {
    ...mapActions(["addMessage"]),
    async getBanks() {
      let serviceResponse = await getBanksApi();
      if (serviceResponse.status) {
        this.banks = serviceResponse.data;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
    }
  }
};
</script>

<style>
.print-endlines {
  white-space: pre-line;
}
</style>